import store from '@/store/index'
import Main from '../views/Main.vue'
import Login from '../views/Login.vue'

const { isFabric } = store.state
const createRoutePath = (rawPath) => (isFabric ? `${rawPath}/:id` : rawPath)

const routes = [
  {
    path: '/login',
    component: Login,
    meta: {
      authRequired: false,
    },
  },
  {
    path: '/',
    component: Main,
    redirect: '/nodes',
    children: [
      {
        path: '/nodes',
        name: 'nodes',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/nodes/Nodes.vue'),
      },
    ],
  },

  {
    path: '',
    component: Main,
    children: [
      {
        path: '/nodes/:id/source',
        name: 'source',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/source/Source.vue'),
      },
      {
        path: '/nodes/:id/source/stream/:streamName',
        name: 'streamDetails',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/source/StreamDetails.vue'),
      },
      {
        path: '/nodes/:id/source/table/:tableName',
        name: 'tableDetails',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/source/TableDetails.vue'),
      },
      {
        path: '/nodes/:id/source/lookupTable/:tableName',
        name: 'lookupTableDetails',
        component: () => import('@/views/source/LookupTableDetails.vue'),
        meta: {
          authRequired: true,
        },
      },
      {
        path: '/nodes/:id/rules',
        name: 'rules',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/rules/Rules.vue'),
      },
      {
        path: '/nodes/:id/rules/:ruleID',
        name: 'ruleDetails',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/rules/RuleDetails.vue'),
      },
      {
        path: '/nodes/:id/rules/:ruleID/topo',
        name: 'ruleTopo',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/rules/RuleTopo.vue'),
      },
      {
        path: '/nodes/:id/extension',
        name: 'extension',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/extension/Extension.vue'),
      },
      // {
      //   path: '/nodes/:id/plugins/sources',
      //   name: 'sources',
      //   meta: {
      //     authRequired: true,
      //   },
      //   component: () => import('@/views/streams/Sources.vue'),
      // },
      {
        path: '/nodes/:id/configuration',
        name: 'configuration',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/configuration/Configuration.vue'),
      },
      {
        path: '/nodes/:id/system',
        name: 'system',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/system/System.vue'),
      },
    ],
  },
  {
    path: '',
    component: Main,
    children: [
      {
        path: '/users',
        name: 'users',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/admin/Users.vue'),
      },
      {
        path: '/roles',
        name: 'roles',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/admin/Roles.vue'),
      },
      {
        path: '/roles/:id',
        name: 'roleDetails',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/admin/RoleDetails.vue'),
      },
    ],
  },
  {
    path: '',
    component: Main,
    children: [
      {
        path: '/change_password',
        name: 'change_password',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/settings/ChangePassword.vue'),
      },
      {
        path: createRoutePath('/language'),
        name: 'language',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/settings/Language.vue'),
      },
      {
        path: createRoutePath('/theme'),
        name: 'theme',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/settings/Theme.vue'),
      },
    ],
  },
  {
    path: '',
    component: Main,
    children: [
      {
        path: createRoutePath('/help'),
        name: 'help',
        meta: {
          authRequired: true,
        },
        component: () => import('@/views/help/Help.vue'),
      },
    ],
  },
  {
    path: '/flowEditor(.*)*',
    component: Main,
    meta: {},
  },
  {
    path: '*',
    // path: '/:pathMatch(.*)',
    component: Main,
    meta: {},
    children: [
      {
        path: '',
        name: 'not-found',
        component: () => import('@/components/NotFound'),
      },
    ],
  },
]

export default routes
